import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import AlertBox from 'components/ui/AlertBox/AlertBox';

const formatTime = (time) => (time >= 0 ? time : 0).toString().padStart(2, '0');

const ExpiryTimestamp = ({ expiryTimestamp }) => {
  const expiryDate = moment(expiryTimestamp);
  const hoursUntil = expiryDate.get('hours');
  const minutesUntil = expiryDate.get('minutes');

  const hasTimeUntil = hoursUntil || minutesUntil;

  if (!hasTimeUntil) {
    return null;
  }

  return (
    <AlertBox variant={AlertBox.variants.WARNING}>
      <FormattedMessage
        id="timeLeftMessage"
        values={{
          counter: <b>{`${formatTime(hoursUntil)}:${formatTime(minutesUntil)}`}</b>
        }}
      />
    </AlertBox>
  );
};

ExpiryTimestamp.propTypes = {
  expiryTimestamp: PropTypes.string
};

export default ExpiryTimestamp;
